import { roundNumber } from '@/services/format.service'

/**
 * Calculates P&L (Profit and Loss) from portfolio value and transfers.
 *
 * Formula: P&L = Portfolio Value - NAV
 * where NAV = Deposits - Withdrawals
 *
 * The result is rounded to fiat precision (2 dp) so that sub-cent
 * floating-point noise from BE-side aggregation does not surface in the UI
 * (e.g. -0.0001 USD).
 *
 * @param portfolioValue - Current portfolio value (last GNAV value)
 * @param deposits - Total deposits
 * @param withdrawals - Total withdrawals (as positive number)
 * @returns Calculated P&L value
 */
export function calculatePnL(
  portfolioValue: number,
  deposits: number,
  withdrawals: number
): number {
  const nav = deposits - withdrawals
  // `|| 0` strips negative zero, which would otherwise render as "-0.00".
  return roundNumber(portfolioValue - nav, 2) || 0
}
